export const SETTLEMENT_PLANNER_LAYOUT = {
  container: 'w-full max-w-7xl mx-auto px-10 sm:px-16 lg:px-24 py-8',
  contentColumn: 'w-full max-w-[894px]',
  title: 'font-display text-2xl sm:text-3xl font-semibold text-cyan-900 leading-tight',
  eyebrow: 'text-xs font-semibold uppercase tracking-wide text-stone-600 mb-2',
  sectionTitle: 'text-lg font-medium text-stone-800 mb-4',
  sectionDescription: 'text-xs text-stone-600 mb-3',
  categoryFilterActive:
    'px-4 py-2 rounded-md text-xs font-semibold transition-all duration-200 border border-cyan-600 bg-cyan-600 text-white shadow-sm',
  categoryFilterInactive:
    'px-4 py-2 rounded-md text-xs font-semibold transition-all duration-200 border border-stone-300 bg-white text-cyan-800 hover:bg-stone-100',
  subtitle: 'text-stone-800 text-lg font-medium leading-relaxed mb-5',
  childrenColumn: 'w-full max-w-[894px] mb-8',
  cardDescription: 'text-sm text-stone-600 mt-1 leading-relaxed',
  notesInput: 'w-full rounded-xl border border-stone-300 px-4 py-3 text-sm text-black placeholder:text-stone-400 focus:border-cyan-600 focus:ring-1 focus:ring-cyan-600 outline-none transition resize-none min-h-[80px]',
  notesLabel: 'text-lg font-medium text-stone-800 mb-3',
  subTaskCard: 'rounded-xl border border-stone-300 bg-white p-[25px]',
  subTaskTitle: 'text-lg font-medium text-stone-800',
  guidanceCard: 'rounded-xl border border-stone-200 bg-stone-50 p-4 mb-4',
  guidanceLabel: 'text-xs font-semibold uppercase tracking-wide text-stone-600 mb-1',
  guidanceBody: 'text-sm text-stone-800 leading-relaxed',
  doneButtonDefault: 'text-xs font-semibold px-3 py-1.5 rounded-md border border-stone-300 bg-white text-stone-700 hover:border-cyan-400 transition-colors',
  doneButtonComplete: 'text-xs font-semibold px-3 py-1.5 rounded-md border border-green-300 bg-green-50 text-green-900',
};

export const SETTLEMENT_PLANNER_PROGRESS_LAYOUT = {
  card: 'rounded-xl border border-stone-300 bg-white p-[25px]',
  progressTitle: 'font-bold text-cyan-900',
  titleAccent: 'font-bold text-cyan-900',
  titleLabel: 'text-stone-800 font-normal',
  count: 'text-xs text-stone-600',
  percent: 'text-base font-bold text-green-600',
  track: 'w-full bg-stone-200 rounded-full h-[7px]',
  fill: 'bg-green-600 h-[7px] rounded-full transition-all duration-500',
  trackerTitle: 'text-xs font-medium text-grey-700',
  trackerCount: 'text-xs text-grey-600',
  trackerTrack: 'w-full bg-grey-200 rounded-full h-[5px]',
  trackerFill: 'bg-blue-500 h-[5px] rounded-full transition-all duration-500',
};

export const SETTLEMENT_PLANNER_PROGRESS = {
  ...SETTLEMENT_PLANNER_PROGRESS_LAYOUT,
};

export const SETTLEMENT_PLANNER_TILE = {
  card: 'w-full border border-neutral-200 rounded-lg p-6 bg-white hover:border-cyan-500 transition-colors text-left',
  numberColumn: 'w-[40px] pl-0 pr-2 mt-0.5',
  title: 'text-base font-medium text-stone-800 leading-tight',
  description: 'text-sm text-stone-700 mt-1 leading-relaxed',
  actions: 'w-full sm:w-auto sm:ml-auto justify-end gap-2 pl-3',
  badge: 'bg-neutral-200 text-black px-2 py-0.5 rounded-xl text-[12px] font-medium',
  button: 'px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white text-sm font-medium rounded-md min-h-[36px]',
  inProgressGlyph: 'w-[25px] h-[25px] rounded-full border-2 border-cyan-300 bg-cyan-100 flex items-center justify-center text-[10px] font-bold text-cyan-700',
  notStartedGlyph: 'w-[25px] h-[25px] rounded-full border-2 border-stone-300 bg-stone-100 flex items-center justify-center text-[10px] font-bold text-stone-600',
};

export const SETTLEMENT_PLANNER_STEP_CARD = SETTLEMENT_PLANNER_TILE;